export const useRatio = (data) => {
  // console.log(w,data)
  return data.map(item => {
    const ratioMapping = {
      '11': '1:1',
      '12': '1:2',
      '21': '2:1',
      '23': '2:3',
      '32': '3:2',
      '34': '3:4',
      '45': '4:5',
      '54': '5:4',
      '916': '9:16',
      '43': '4:3',
      '169': '16:9',
    };
    // console.log(item.ratio, ratioMapping[item.ratio])
    const ratios = ratioMapping[item.ratio].split(":")

    const ratioHeight = 384 / (ratios[0] / ratios[1])
    // return { ...item, aspectRatio: `${ratios[0]}/${ratios[1]}` }
    return { ...item, aspectRatio: `${ratios[0]}/${ratios[1]}`, ratioHeight }
  })
}
